import React from 'react';
import { LinearProgress, Box, Typography } from '@mui/material';

import { formatNumberToEuroString } from '../utils/FormatToPrice';

const ProgressBar = ({ target = 0, solde = 0 }) => {

    // let progressPourcentage = solde === 0 && target === 0 || solde > target ? 100 : Math.round(solde * 100 / target);
    let progressPourcentage = Math.round(solde * 100 / target);
    if (progressPourcentage > 100) {
        progressPourcentage = 100
    }
    if (progressPourcentage < 0) {
        progressPourcentage = 0
    }

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', width: '100%', marginY: 2 }}>
                <Box sx={{ marginRight: 1 }}>
                    <Typography variant="body2" color="text.secondary">
                        0€
                    </Typography>
                </Box>

                <Box sx={{ width: '100%' }}>

                    <Box
                        sx={{
                            paddingLeft: `${progressPourcentage}%`,
                        }}
                    >
                        <Typography
                            sx={{
                                transform: 'translateX(-50px)',
                                width: '100px',
                                textAlign: 'center'
                            }}
                            variant="body2"
                            color="text.secondary"
                        >
                            {solde} €
                        </Typography>
                    </Box>

                    <Box sx={{ width: '100%', mr: 1 }}>
                        <LinearProgress sx={{ width: '100%', marginY: 1 }} variant="determinate" color="primary" value={progressPourcentage} />
                    </Box>

                </Box>

                <Box sx={{ marginLeft: 1 }}>
                    <Typography variant="body2" color="text.secondary">
                        {formatNumberToEuroString(target)}€
                    </Typography>
                </Box>
            </Box>
        </>
    )
}

export default ProgressBar;

